import React from 'react';
import { Analytics } from '@gik/core/utils';
import replacePath from '@gik/core/utils/replacePath';

export default function useViewFeaturedPageAnalytics(): void {
  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('origin') && urlParams.get('origin') === 'homepage' && urlParams.has('category')) {
      const category = urlParams.get('category');

      // prevent duplication
      urlParams.delete('origin');
      urlParams.delete('category');

      replacePath(urlParams);

      const inkindPageUrl = window.location.href;

      Analytics.fireEvent('ViewFeaturedPage', {
        category,
        inkindPageUrl,
      });
    }
  }, []);
}
